import { createContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import RouteConstants from "../../../constants/routeConstants.json";
import ContentData from "../../../constants/contentFile.json";
import { handleApiError, StateOptions } from "../../../constants/Constants";
import { getErrorMessage, validateField } from "../AddDealer/AddDealerView";
import { updateDealerApi } from "../../../api/Api";
import { useCookies } from "react-cookie";
export const EditDealerContext = createContext({});

export const EditDealerContextProvider = ({ children }) => {
  const [formData, setFormData] = useState({
    customerCode: "",
    customerName: "",
    mobile: "",
    region: "",
    district: "",
    city: "",
    streetOrHouseNumber: "",
    postalCode: "",
  });
  const [validationErrors, setValidationErrors] = useState({
    customerCode: "",
    customerName: "",
    mobile: "",
    region: "",
    district: "",
    city: "",
    streetOrHouseNumber: "",
    postalCode: "",
  });
  const [successAlertShow, setSuccessAlertShow] = useState(false);
  const [successAlertMessage, setSuccessAlertMessage] = useState("");
  const [statusValue, setStatusValue] = useState(0);
  const [errorPopup, setErrorPopup] = useState(false);
  const [errorPopupMessage, setErrorPopupMessage] = useState("");
  const [spinnerStatus, setSpinnerStatus] = useState(false);
  const [buttonText, setButtonText] = useState("");
  const [currentRegion, setCurrentRegion] = useState("");
  const [cookies, setCookie, removeCookie] = useCookies(["user"]);

  const location = useLocation();
  const dealerDetails = location?.state?.dealerData;
  const currentPage = location?.state?.page;
  const permissionAccess = JSON.parse(
    localStorage.getItem("permissions")
  )?.filter((item) => {
    return item.feature === "67b4165e2efc50c984271c80";
  })[0];

  const navigate = useNavigate();

  useEffect(() => {
    const stateOption = StateOptions.find(
      (state) => state.label === dealerDetails.region
    );
    const customerCodeString = String(dealerDetails.customerCode || "");
    setCurrentRegion(stateOption?.label);
    setFormData({
      ...dealerDetails,
      customerCode: customerCodeString,
      streetOrHouseNumber: dealerDetails?.streetOrHouseNumber,
      region: stateOption?.value,
    });
  }, [dealerDetails]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    const isValid = validateField(name, value);
    setValidationErrors((prevErrors) => ({
      ...prevErrors,
      [name]: isValid ? "" : getErrorMessage(name, value),
    }));
  };

  const handleSelectData = (e) => {
    const selectedRegionId = e.target.value;
    const selectedRegion = StateOptions.find(
      (region) => region?.value === selectedRegionId
    );
    const regionValue = selectedRegion ? selectedRegion.label : "";
    setCurrentRegion(regionValue);
    setFormData((prevData) => ({
      ...prevData,
      region: selectedRegionId,
    }));

    setValidationErrors((prevErrors) => ({
      ...prevErrors,
      region: regionValue ? "" : getErrorMessage("region", ""),
    }));
  };

  const updateDealer = async (e) => {
    e.preventDefault();
    const newErrors = {};
    let hasErrors = false;

    Object.keys(formData).forEach((fieldName) => {
      const isValid = validateField(fieldName, formData[fieldName]);
      newErrors[fieldName] = isValid
        ? ""
        : getErrorMessage(fieldName, formData[fieldName]);
      if (!isValid) hasErrors = true;
    });

    setValidationErrors(newErrors);

    if (!hasErrors) {
      setSpinnerStatus(true);
      try {
        const response = await updateDealerApi(dealerDetails?._id, {
          ...formData,
          region: currentRegion ? currentRegion : formData.region,
        });
        if (response.data.statusCode === 200) {
          setSpinnerStatus(false);
          setSuccessAlertShow(true);
          setSuccessAlertMessage(response?.data?.message);
          setErrorPopup(false);
        }
      } catch (error) {
        handleApiError(
          error,
          setStatusValue,
          setErrorPopupMessage,
          setErrorPopup,
          setButtonText
        );
      }
      setSpinnerStatus(false);
    }
  };

  const goToLogin = () => {
    navigate(RouteConstants.LOGIN);
    removeCookie("x-access-token");
  };

  const goToDealerList = () => {
    navigate(RouteConstants.LIST_DEALER, { state: { page: currentPage } });
  };
  const goToDealerDetails = () => {
    navigate(RouteConstants.DEALER_DETAILS, {
      state: { id: dealerDetails?._id, page: currentPage },
    });
  };

  const providerValue = {
    formData,
    goToDealerList,
    handleChange,
    updateDealer,
    successAlertMessage,
    successAlertShow,
    spinnerStatus,
    handleSelectData,
    validationErrors,
    errorPopup,
    errorPopupMessage,
    setErrorPopup,
    goToLogin,
    buttonText,
    statusValue,
    goToDealerDetails,
  };
  return (
    <EditDealerContext.Provider value={providerValue}>
      {children}
    </EditDealerContext.Provider>
  );
};
